(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v3"] && !Shopify.designMode) return;
  try {
    

 $(document).ready(function(){
    $('.slick-side-h3').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000, // 5000ms = 5 seconds
      arrows: true,
      dots: true
    });
  });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sxm-gallery-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  if (typeof lightbox !== "undefined") {
    lightbox.option({
      resizeDuration: 200,
      wrapAround: true
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
